exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home-hero{margin:0;height:100vh;background:#202020;padding:0;overflow:hidden}.home-hero .main{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;align-items:center;justify-content:left;height:100%;overflow-x:hidden}.home-hero .main .hidden{display:none}.home-hero .main .logo-container{display:flex;width:60%;height:100%;margin-right:auto;margin-left:auto;max-height:240px;position:relative}@media (min-width:76.8em){.home-hero .main .logo-container{width:50%}}.home-hero .main .logo-container .reveal{fill:#eee}.home-hero .main .logo-container .mask{fill:#111;opacity:0}.home-hero .main .logo-container .logo-type{display:flex;width:100%;height:100%;position:absolute;margin-right:auto;margin-left:auto}.home-hero .main .logo-container .logo-type svg{width:100%;height:auto}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-HomeHero/_index.scss
 ** module id = 190
 ** module chunks = 0
 **/